export default __webpack_public_path__ + "static/media/logopp.445ff137.png";